import Vue from 'vue';

//导入组件
import {
    Loading,
    Notification,
    MessageBox,
    Message,
    Button,
    ButtonGroup,
    Select,
    OptionGroup,
    Option,
    Form,
    FormItem,
    Input,
    InputNumber,
    Col,
    Row,
    Container,
    Aside,
    Menu,
    MenuItem,
    Submenu,
    MenuItemGroup,
    Header,
    Main,
    Drawer,
    Tooltip,
    Switch,
    Scrollbar,
    Breadcrumb,
    BreadcrumbItem,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    ColorPicker,
    Dialog,
    Descriptions,
    DescriptionsItem,
    Tag,
    Link,
    Avatar,
    DatePicker,
    Table,
    TableColumn,
    Tree,
    Cascader,
    Popover,
    Pagination,
    PageHeader,
    Divider,
    Checkbox,
    CheckboxGroup,
    CheckboxButton,
    Radio,
    RadioGroup,
    Collapse,
    CollapseItem,
    Card,
    Tabs,
    TabPane,
    Autocomplete,
    Popconfirm,
    Badge,
    RadioButton,
    TimeSelect,
    TimePicker,
    Progress,
    Calendar,
    Steps,
    Step,
    Upload,
    Alert,
    Image,
    Slider,
    Rate
} from 'element-ui'

//注册组件
let useObj = {
    Image,
    Cascader,
    directive: Loading.directive,
    Button,
    ButtonGroup,
    Select,
    OptionGroup,
    Option,
    Form,
    FormItem,
    Input,
    Col,
    Row,
    Container,
    Aside,
    Menu,
    MenuItem,
    Submenu,
    MenuItemGroup,
    Header,
    Main,
    Drawer,
    Tooltip,
    Switch,
    Scrollbar,
    Breadcrumb,
    BreadcrumbItem,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    ColorPicker,
    Dialog,
    Descriptions,
    DescriptionsItem,
    Tag,
    Link,
    Avatar,
    DatePicker,
    Table,
    TableColumn,
    Tree,
    Popover,
    Pagination,
    PageHeader,
    Divider,
    Checkbox,
    CheckboxGroup,
    CheckboxButton,
    Radio,
    RadioGroup,
    Collapse,
    CollapseItem,
    Card,
    Tabs,
    TabPane,
    Autocomplete,
    Popconfirm,
    InputNumber,
    Badge,
    RadioButton,
    TimeSelect,
    TimePicker,
    Progress,
    Calendar,
    Steps,
    Step,
    Upload,
    Alert,
    Slider,
    Rate
};

//挂载方法
let prototypeObj = {
    MessageBox,
    Alert: MessageBox.alert,
    Confirm: MessageBox.confirm,
    Prompt: MessageBox.prompt,
    Notify: Notification,
    Message,
    Notification
};

function VueComponent() {
    for (let x in useObj) {
        Vue.use(useObj[x]);
    }
}

function VuePrototype() {
    for (let x in prototypeObj) {
        let str = x.slice(0, 1).toLowerCase() + x.slice(1);
        Vue.prototype[`$${str}`] = prototypeObj[x];
    }
}

Vue.prototype.$ELEMENT = {
    size: 'small',
};

// /*修复：Select组件在IOS唤不起软键盘*/
let userAgent = window.navigator.userAgent;
let isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
if(isIOS){
    Select.computed.readonly = function () {
        const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
        return !(this.filterable || this.multiple || !isIE) && !this.visible;
    };
}

//导出方法
export function elementConfig() {
    VueComponent();
    VuePrototype();
}
